/* Preserve the existing product cards and native history scrolling. */
(function (global) {
  'use strict';
  function readState(storage, key) {
    try {
      var raw = storage().getItem(key);
      if (!raw || raw.length > 12000) return null;
      var state = JSON.parse(raw);
      return state && state.version === 1 && typeof state.tabs === 'object' && state.tabs !== null && !Array.isArray(state.tabs) ? state : null;
    } catch (error) { return null; }
  }
  function writeState(storage, key, state) {
    try { storage().setItem(key, JSON.stringify(state)); } catch (error) { /* Storage is optional. */ }
  }
  function productPath(href) {
    if (typeof href !== 'string') return null;
    // Liquid product URLs are root-relative; retain the complete locale path.
    var path = href.split(/[?#]/)[0];
    return path.startsWith('/') && !path.startsWith('//') && /\/products\/[^/]+\/?$/.test(path) ? path : null;
  }
  function restoreOffset(saved, links, offsets) {
    if (!saved || !links.length) return 0;
    var index = typeof saved.href === 'string' ? links.indexOf(saved.href) : -1;
    if (index < 0) {
      var path = productPath(saved.href);
      if (path) index = links.findIndex(function (href) { return productPath(href) === path; });
    }
    // A removed/reordered card must not restore to an unrelated product.
    if (index < 0) return 0;
    return Math.max(0, offsets[index] || 0);
  }
  function initSection(section, win) {
    if (section.__skHomeBrowse) return section.__skHomeBrowse;
    var tabs = Array.from(section.querySelectorAll('.product-tab'));
    var panels = Array.from(section.querySelectorAll('.tab-content'));
    if (!tabs.length || !panels.length) return null;
    var key = 'skHomeShelf:' + section.dataset.skHomeBrowse;
    var state = { version: 1, active: tabs[0].dataset.prodtab, tabs: {} };
    var storage = function () { return win.sessionStorage; };
    var listeners = [];
    var observers = [];
    var timer;
    var restoring = false;
    function on(node, event, fn, options) { node.addEventListener(event, fn, options); listeners.push(function () { node.removeEventListener(event, fn, options); }); }
    var shelves = panels.map(function (panel) {
      var grid = panel.querySelector('.product-grid');
      return { panel: panel, grid: grid, cards: grid ? Array.from(grid.children) : [], controls: panel.querySelector('[data-sk-shelf-controls]') };
    });
    function offsets(shelf) {
      if (!shelf.grid) return [];
      var rect = shelf.grid.getBoundingClientRect();
      var padding = parseFloat(win.getComputedStyle(shelf.grid).paddingLeft) || 0;
      return shelf.cards.map(function (card) { return card.getBoundingClientRect().left - rect.left + shelf.grid.scrollLeft - padding; });
    }
    function capture(shelf) {
      if (!shelf.grid || shelf.panel.hidden || !shelf.cards.length || shelf.grid.scrollWidth <= shelf.grid.clientWidth + 2) return;
      var stops = offsets(shelf);
      var nearest = stops.reduce(function (best, value, index) { return Math.abs(value - shelf.grid.scrollLeft) < Math.abs(stops[best] - shelf.grid.scrollLeft) ? index : best; }, 0);
      var link = shelf.cards[nearest].querySelector('a.product-card');
      if (link) state.tabs[shelf.panel.id] = { href: link.getAttribute('href') };
    }
    function save() {
      if (restoring) return;
      shelves.forEach(capture);
      writeState(storage, key, state);
    }
    function update(shelf) {
      if (!shelf.grid || !shelf.controls || shelf.panel.hidden) return;
      var grid = shelf.grid;
      var overflow = grid.scrollWidth > grid.clientWidth + 2;
      shelf.controls.hidden = !overflow;
      if (!overflow || !shelf.cards.length) return;
      var bounds = grid.getBoundingClientRect();
      var visible = [];
      shelf.cards.forEach(function (card, index) { var r = card.getBoundingClientRect(); if (r.right > bounds.left + 2 && r.left < bounds.right - 2) visible.push(index + 1); });
      var first = visible[0] || 1;
      var last = visible[visible.length - 1] || first;
      shelf.controls.querySelector('[data-sk-shelf-position]').textContent = (first === last ? first : first + '–' + last) + ' / ' + shelf.cards.length;
      shelf.controls.querySelector('[data-sk-shelf-prev]').disabled = grid.scrollLeft <= 2;
      shelf.controls.querySelector('[data-sk-shelf-next]').disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2;
      shelf.controls.querySelector('[data-sk-shelf-progress]').style.width = Math.min(100, (grid.scrollLeft + grid.clientWidth) / grid.scrollWidth * 100) + '%';
    }
    function restoreShelf(shelf) {
      if (!shelf.grid || shelf.panel.hidden) return;
      var links = shelf.cards.map(function (card) { var link = card.querySelector('a.product-card'); return link && link.getAttribute('href'); });
      shelf.grid.scrollLeft = restoreOffset(state.tabs[shelf.panel.id], links, offsets(shelf));
      update(shelf);
    }
    function select(tab, focus) {
      state.active = tab.dataset.prodtab;
      tabs.forEach(function (item) { var active = item === tab; item.classList.toggle('active', active); item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
      panels.forEach(function (panel) { var active = panel.id === state.active; panel.hidden = !active; panel.classList.toggle('active', active); });
      var current = shelves.find(function (shelf) { return shelf.panel.id === state.active; });
      var more = section.querySelector('#skProdMoreLink');
      var destination = current && current.panel.querySelector('.section-more a');
      if (more && destination) more.href = destination.href;
      if (current) restoreShelf(current);
      if (focus) tab.focus();
    }
    var nav = section.querySelector('.product-tabs-nav');
    if (nav) {
      var tablist = section.ownerDocument.createElement('div');
      tablist.className = 'sk-home-product-tabs'; tablist.setAttribute('role', 'tablist'); tablist.setAttribute('aria-label', '商品一覧の切り替え');
      nav.insertBefore(tablist, tabs[0]); tabs.forEach(function (tab) { tablist.appendChild(tab); });
    }
    tabs.forEach(function (tab, index) {
      tab.type = 'button';
      tab.id = 'SkHomeTab-' + section.dataset.skHomeBrowse + '-' + index;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', tab.dataset.prodtab);
      var panel = panels.find(function (item) { return item.id === tab.dataset.prodtab; });
      if (panel) { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tab.id); }
      on(tab, 'click', function () { save(); select(tab, false); save(); });
      on(tab, 'keydown', function (event) {
        var target;
        if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = tabs.length - 1;
        else return;
        event.preventDefault(); save(); select(tabs[target], true); save();
      });
    });
    shelves.forEach(function (shelf) {
      if (!shelf.grid || !shelf.controls) return;
      function move(direction) {
        var stops = offsets(shelf);
        var x = shelf.grid.scrollLeft;
        var target = direction > 0 ? stops.find(function (stop) { return stop > x + 2; }) : stops.slice().reverse().find(function (stop) { return stop < x - 2; });
        if (target === undefined) target = direction > 0 ? shelf.grid.scrollWidth : 0;
        shelf.grid.scrollTo({ left: Math.max(0, target), behavior: win.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      on(shelf.controls.querySelector('[data-sk-shelf-prev]'), 'click', function () { move(-1); });
      on(shelf.controls.querySelector('[data-sk-shelf-next]'), 'click', function () { move(1); });
      on(shelf.grid, 'keydown', function (event) {
        if (event.target !== shelf.grid || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      });
      on(shelf.grid, 'scroll', function () { update(shelf); capture(shelf); clearTimeout(timer); timer = setTimeout(save, 150); }, { passive: true });
      if (win.ResizeObserver) { var observer = new win.ResizeObserver(function () { restoreShelf(shelf); }); observer.observe(shelf.grid); observers.push(observer); }
    });
    function restore(event) {
      if (event && !event.persisted) return;
      var stored = readState(storage, key);
      if (!stored) { shelves.forEach(update); return; }
      restoring = true;
      state = stored;
      select(tabs.find(function (tab) { return tab.dataset.prodtab === stored.active; }) || tabs[0], false);
      restoring = false;
    }
    select(tabs[0], false);
    var navigation = win.performance && win.performance.getEntriesByType('navigation')[0];
    if (navigation && navigation.type === 'back_forward') restore();
    on(win, 'pageshow', restore);
    on(win, 'pagehide', save);
    on(section, 'click', function (event) { if (event.target.closest('a.product-card')) save(); }, true);
    section.__skHomeBrowse = { restore: restore, destroy: function () { clearTimeout(timer); listeners.forEach(function (remove) { remove(); }); observers.forEach(function (observer) { observer.disconnect(); }); if (nav && tablist) { tabs.forEach(function (tab) { nav.insertBefore(tab, tablist); }); tablist.remove(); } delete section.__skHomeBrowse; } };
    return section.__skHomeBrowse;
  }
  var api = { readState: readState, writeState: writeState, restoreOffset: restoreOffset, initSection: initSection };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.document) return;
  function init(root) { if (root.matches && root.matches('[data-sk-home-browse]')) initSection(root, global); root.querySelectorAll('[data-sk-home-browse]').forEach(function (section) { initSection(section, global); }); }
  if (!global.__skHomeBrowseLifecycle) {
    global.__skHomeBrowseLifecycle = true;
    global.document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    global.document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-sk-home-browse]').forEach(function (section) { if (section.__skHomeBrowse) section.__skHomeBrowse.destroy(); }); });
  }
  init(global.document);
})(typeof window === 'undefined' ? globalThis : window);
